import { Text, TextProps } from '@blockworks/ui/components';

import { MetricFormatter } from '@/components/metrics/types';

interface MetricValueProps extends Partial<Pick<TextProps, 'size' | 'weight'>> {
    value?: string | number;
    format?: MetricFormatter;
    showChangeDirection?: boolean;
    isLoading?: boolean;
}

const MetricValue = ({
    value,
    format,
    showChangeDirection,
    isLoading,
    weight = 'regular',
    ...rest
}: MetricValueProps) => {
    if (isLoading || value === undefined) {
        return (
            <Text color="deselect" {...rest}>
                -
            </Text>
        );
    }

    const displayProps: Partial<TextProps> = {
        ...rest,
        weight,
        color: 'muted',
        children: format ? format(value) : value,
    };

    if (showChangeDirection) {
        const parsedValue = Number(value);
        if (parsedValue > 0) {
            displayProps.color = 'success';

            displayProps.children = `+${displayProps.children}`;
        }
        if (parsedValue < 0) {
            displayProps.color = 'danger';
        }
        if (parsedValue === 0) {
            displayProps.color = 'deselect';
        }
    }

    return <Text {...displayProps} />;
};

export default MetricValue;
